import { create } from 'zustand';
import { type AuthorizationResponse, AuthorizationStatus } from '@/api/model/authorization';
import { UserRole } from '@/api/model/profile';

export const notAuthorized: AuthorizationResponse = { status: AuthorizationStatus.NOT_AUTHORIZED };

export interface AuthState {
    auth: AuthorizationResponse;
    loading: boolean;
    setAuth: (auth: AuthorizationResponse) => void;
    clearAuth: () => void;
    setLoading: (loading: boolean) => void;
}

export const useAuthorization = create<AuthState>((set) => ({
    auth: notAuthorized,
    loading: false,
    setAuth: (auth: AuthorizationResponse) => set(() => ({ auth: auth })),
    clearAuth: () => set(() => ({ auth: notAuthorized })),
    setLoading: (loading: boolean) => set(() => ({ loading: loading })),

}));

export const profileSelector = (state: AuthState) => (state.auth.profile );
export const userRoleSelector = (state: AuthState) => (state.auth.profile ? state.auth.profile.role : UserRole.UNKNOWN );
export const subscriptionSelector = (state: AuthState) => ( state.auth.profile?.subscription ? state.auth.profile.subscription : undefined );
export const authorizationStatusSelector = (state: AuthState) => ( state.auth.profile ? AuthorizationStatus.AUTHORIZED : AuthorizationStatus.NOT_AUTHORIZED );
